<mat-nav-list [ngClass]="horizontal ? 'list-horizontal' : ''" *ngIf="auth.user$ | async as user; else public">
  <a mat-list-item routerLink="/broadcast" routerLinkActive="active-link">Broadcasts</a>
  <a mat-list-item routerLink="/score-sheets" routerLinkActive="active-link">Score sheets</a>
  <!--<a mat-list-item routerLink="/book" routerLinkActive="active-link">Book</a>-->
  <a mat-list-item routerLink="/support" routerLinkActive="active-link">Support</a>
  <a mat-list-item href="/api-docs" target="_blank">OpenAPI</a>
</mat-nav-list>
<ng-template #public>
  <mat-nav-list [ngClass]="horizontal ? 'list-horizontal' : ''">
    <a mat-list-item routerLink="/about" routerLinkActive="active-link">About</a>
    <a mat-list-item routerLink="/pricing" routerLinkActive="active-link">Pricing</a>
    <a mat-list-item routerLink="/references" routerLinkActive="active-link">References</a>
    <a mat-list-item routerLink="/score-sheets" routerLinkActive="active-link">Score sheets</a>
  </mat-nav-list>
</ng-template>
